import { render } from "./TheDashboard.vue?vue&type=template&id=9b63d7c4&scoped=true"
import script from "./TheDashboard.vue?vue&type=script&lang=js"
export * from "./TheDashboard.vue?vue&type=script&lang=js"

import "./TheDashboard.vue?vue&type=style&index=0&id=9b63d7c4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b63d7c4"]])

export default __exports__